import React from "react";
import { withTranslation } from "react-i18next";

const OrderItem = (props) => {
  const { picture, brand, name, points, quantity, t } = props;
  return (
    <div className="order_item">
      <div className="product_picture">
        <img src={picture} alt="" />
      </div>

      <div className="product_infos">
        <div className="product_brand">{brand}</div>
        <div className="product_name">{name}</div>
        <div className="product_price">
          {points} {t("points")}
        </div>
      </div>

      <div className="product_qty">
        <div className="qty">x{quantity}</div>
      </div>
    </div>
  );
};

export default withTranslation()(OrderItem);
